import * as React from "react";
import CouncilHeaderWidget from "./CouncilHeaderWidget";
import { connect } from "react-redux";
import { ICouncil } from "src/interfaces";
import Loading from "src/components/general/Loading";

interface ICouncilHeaderProps {
  councils: ICouncil[];
}

const CouncilsHeader = (props: ICouncilHeaderProps) => {
  const primary = props.councils[0]
  const others = props.councils.slice(-3)
  return (
    <div className="container pt-5">
      <div className="flex flex-wrap">
        <div className="w-full lg:w-1/4 xl:w-1/4 mb-5">
          <h2 className="text-center p-4 text-cct-blue">My Council</h2>
          <div className="flex mb-4">
          {!!primary ? (
            <div className="w-full">
              <CouncilHeaderWidget
                name={primary.name}
                ordinal={1}
                feature={ true }
                councilId={primary.id}
              />
            </div>
          ) : null}
          </div>
        </div>
        <div className="w-full lg:w-3/4 xl:w-3/4">
          <h2 className="text-center p-4 text-cct-blue whitespace-no-wrap">
            Councils to compare
          </h2>
          <div className="flex flex-wrap mb-4">
            {!!others
              ? others.map((council, index) => {
              	return (
	                <div
	                	key={index}
	                 	className="w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-5">
	                    <CouncilHeaderWidget
	                      ordinal={index + 2}
	                      name={council.name}
	                      feature={ false }
	                      councilId={council.id}
	                    />
	                </div>
                );
              })
              : <Loading />}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  councils: state.selected.councils,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilsHeader);



// WEBPACK FOOTER //
// ./src/components/CouncilsHeader/index.tsx